import { render, staticRenderFns } from "./TabServicesProtocol.vue?vue&type=template&id=58ce46a6&scoped=true&"
import script from "./TabServicesProtocol.vue?vue&type=script&lang=js&"
export * from "./TabServicesProtocol.vue?vue&type=script&lang=js&"
import style0 from "./TabServicesProtocol.vue?vue&type=style&index=0&id=58ce46a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ce46a6",
  null
  
)

export default component.exports